import React, { Fragment, useContext } from 'react';
import usePhotoGalleryStyles from './styles';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';

import NextImageRenderer from '../../components/nextImageRenderer';
import { useLinkBuilder } from '../../hooks/useLinkBuilder';

export default function PhotoGallery({ sectionData, sectionIndex }) {
  const {
    templateId,
    navList,
    isPreview,
    isEdit,
    basePath,
    isMasterTemplate,
    isMobile,
    layout: { containerWidth }
  } = useContext(PageContext);

  const [nodeData] = sectionData.components;
  const carouselList = nodeData?.cardCarousel?.components;
  const cardsCount = carouselList?.length;
  const slidesToShow = isMobile ? 1 : 2;
  const classes = usePhotoGalleryStyles({
    containerWidth,
    cardsCount,
    slidesToShow,
    isMobile
  });

  const settings = {
    className: classes.sliderContainer,
    dots: isMobile,
    infinite: true,
    speed: 500,
    slidesToShow,
    centerMode: true,
    centerPadding: isMobile ? '10px 0 0' : '80px 0 0',
    arrows: false
  };

  const handleClick = (data) => {
    let redirectUrl;

    const { isExistingLink, link } = data;
    if (isExistingLink && link === 'courses') {
      redirectUrl = `//${basePath}/courses`;
    } else if (isExistingLink && link) {
      // const { pageId } = navList.find((el) => el.slug === data?.link) || {};
      redirectUrl = `//${basePath}/${link}`;
    } else {
      redirectUrl = link;
    }

    if (redirectUrl) {
      window.open(redirectUrl, '_blank');
    }
  };

  // useLinkBuilder(data);

  const carouselContent = carouselList?.map((el, idx) => {
    const metadata = el?.cardImage?.metadata;
    const link = el?.cardImage?.metadata?.link;

    return (
      <Fragment key={idx}>
        <div
          onClick={() => handleClick(metadata)}
          className={`${classes.singleCard} ${link && classes.cursorPointer}`}
        >
          {/* <img
            ref={el?.cardImage?.refSetter}
            className={classes?.carouselImage}
            src={el?.cardImage?.metadata?.value}
            alt=""
          /> */}
          <NextImageRenderer
            src={el?.cardImage?.metadata?.value}
            ref={el?.cardImage?.refSetter}
            className={classes?.carouselImage}
            sectionIndex={sectionIndex}
          />
        </div>
      </Fragment>
    );
  });

  return (
    <>
      <div className={classes.container}>
        <div className={classes.sectionContainer}>
          <div className={classes.cardHeading}>
            <span
              ref={nodeData?.carouselHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.carouselHeading?.metadata?.value
              }}
            />
          </div>
          <h2 className={classes.title}>
            <span
              ref={nodeData?.title?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.title?.metadata?.value
              }}
            />
          </h2>

          {cardsCount > slidesToShow ? (
            <Carousel hideArrow={isMobile} settings={settings}>
              {carouselContent}
            </Carousel>
          ) : (
            <div className={classes.contentRow}>{carouselContent}</div>
          )}
        </div>
      </div>
    </>
  );
}
